import {
  persistRightSidebarVisibility,
  resolveRightSidebarInitialVisibility,
} from 'dashboard/helper/rightSidebarResize';

const state = {
  selectedAIContact: null,
  showRightSidebar: resolveRightSidebarInitialVisibility(),
};

const getters = {
  showRightSidebar: ($state) => $state.showRightSidebar,
  selectedAIContact: ($state) => $state.selectedAIContact,
};

const mutations = {
  SET_AI_CONTACT($state, contact) {
    $state.selectedAIContact = contact;
  },
  TOGGLE_RIGHT_SIDEBAR($state) {
    $state.showRightSidebar = !$state.showRightSidebar;
    persistRightSidebarVisibility({ isVisible: $state.showRightSidebar });
  },
};

const actions = {
  setAIContact({ commit }, contact) {
    commit('SET_AI_CONTACT', contact);
  },
  toggleRightSidebar({ commit }) {
    commit('TOGGLE_RIGHT_SIDEBAR');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
